import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=58ce5102"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=58ce5102&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports